module.exports = __webpack_public_path__ + "img/new-logo.7b30396.png";